import { render, staticRenderFns } from "./CmpMessage.vue?vue&type=template&id=03c380ab&"
import script from "./CmpMessage.vue?vue&type=script&lang=js&"
export * from "./CmpMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports